import { createClass as _createClass, classCallCheck as _classCallCheck } from "./_virtual/_rollupPluginBabelHelpers.js";
var MediaError = /* @__PURE__ */ _createClass(function MediaError2(msg, data) {
  _classCallCheck(this, MediaError2);
  this.type = "file";
  this.message = msg;
  this.data = data;
});
export { MediaError };
